import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input-radio-button',
  templateUrl: './input-radio-button.component.html',
  styleUrls: ['./input-radio-button.component.scss']
})
export class InputRadioButtonComponent implements OnInit {
  @Input() labelName: string;
  @Input() inputFormControl: FormControl;
  @Input() name: string;
  @Input() readOnlyMode = false;
  @Input() submitted = false;

  public id: string;

  constructor() { }

  ngOnInit(): void {
    if (this.labelName) {
      this.id = this.labelName.split(' ').join('_').toString().concat('_' + Math.random());
    }
  }
}
